export enum BrowserStorage {
  Prefix = 'apps__',
  AuthPrefix = 'prefix',
  BHistoryGridFilters = 'BHistoryGridFilters',
  BHistorySPanelFilters = 'BHistorySPanelFilters',
  CalendarFilters = 'CalendarFilters',
  CustomerProblem = 'CustomerProblem',
  ErrorPage = 'ErrorPage',
  RestoreFileTeams = 'RestoreFileTeams',
  RestorePoints = 'RestorePoints',
  RestoreToAnotherUser = 'RestoreToAnotherUser',
  RestoreToAnotherUserSettings = 'RestoreToAnotherUserSettings',
  SkippedItemsHistory = 'SkippedItemsHistory',
  SPointDisabled = 'SPointDisabled',
  SPointNoSiteBackup = 'SPointNoSiteBackup',
  Token = 'token',
  UpdateInterval = 'UpdateInterval'
}
